import { proxy } from 'valtio';

import type { Region } from 'models';

const state = proxy<{
    defaultRegion: Region | null;
}>({
    defaultRegion: null,
});

export { state };
